import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderMobileGraphFooter.vue?vue&type=template&id=2c1b0d22&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-mobile-graph-footer.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-mobile-graph-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderMobileGraphFooter.vue?vue&type=style&index=0&id=2c1b0d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b0d22",
  null
  
)

export default component.exports